import { Channel } from './channel';

export class Category {
    Id: number;
    UserId: number;
    Name: string;
    Channels: Channel[];
    Description: string;    
    Active: boolean;
    ModifiedDate: Date;
    CreatedDate: Date;    
}